/**
 * Shared Sanity Image Builder Utility
 *
 * This module provides a factory function for creating Sanity image URL builders.
 * Used by both server and client code with their respective config sources.
 */

import { createImageUrlBuilder } from '@sanity/image-url';

export type ImageBuilder = ReturnType<typeof createImageUrlBuilder>;

/**
 * Create a Sanity image URL builder with the given project configuration.
 */
export function createImageBuilder(projectId: string, dataset: string) {
  return createImageUrlBuilder({ projectId, dataset });
}
